import Tabs from 'antd/lib/tabs';
import 'antd/lib/tabs/style/index.css';

export default Tabs;
